/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface DemandeApprenantSearch
 */
export interface DemandeApprenantSearch {
    /**
     * 
     * @type {number}
     * @memberof DemandeApprenantSearch
     */
    idApprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DemandeApprenantSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DemandeApprenantSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeApprenantSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeApprenantSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DemandeApprenantSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeApprenantSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DemandeApprenantSearch interface.
 */
export function instanceOfDemandeApprenantSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeApprenantSearchFromJSON(json: any): DemandeApprenantSearch {
    return DemandeApprenantSearchFromJSONTyped(json, false);
}

export function DemandeApprenantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeApprenantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DemandeApprenantSearchToJSON(value?: DemandeApprenantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idApprenant': value.idApprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

